import style from "../../style/test_result/guide/learningStrategy.module.scss";
import {BrainType} from "../../../types/testResult";
import {Trans, useTranslation} from "react-i18next";
import React from "react";
import {useJobInfoFunctions} from "./hooks/useJobInfoFunctions";

interface Args {
    brainType: BrainType;
}

/* eslint-disable max-len */
export function RecommendationLeftJobDetail({brainType}:Args) {
    const {t} = useTranslation("guideRecommendationJob");

    const job = 'recommendation.left.futureJob'
    const brainValue = brainType === BrainType.BALANCED ? `${t('summary.left.title')} -` : '';
    const {renderListItems} = useJobInfoFunctions();


    return(
        <>
            {/*좌뇌우세형 - 적성 및 주성향 판단 */}
            {brainValue && (
                <article className={style.article}>
                    <h2 className={style.title}>{t('recommendation.left.aptitude.title')}</h2>
                    <Trans t={t} i18nKey='recommendation.left.aptitude.description'
                           values={{blank: '\u00A0'}}
                           components={{
                               br: <br/>,
                               description: <p className={style.description}/>,
                           }}/>
                </article>
            )}

            {/*좌뇌우세형 - 추천 직업군 */}
            <article className={style.article}>
                <h2 className={style.title}>
                    <Trans t={t} i18nKey='recommendation.left.job.title' values={{name: brainValue}}/>
                </h2>
                <p className={style.description}>
                    &nbsp;{t('recommendation.left.job.description')}
                </p>
            </article>

            {/*좌뇌우세형 - 미래 예상 직업군 */}
            <article className={style.article}>
                <h2 className={style.title}>
                    <Trans t={t} i18nKey='recommendation.left.futureJob.title' values={{name: brainValue}}/>
                </h2>
                <article className={style.subArticle}>
                    <section>
                        <h3 className={style.title}>
                            <span className={style.number}>1</span>
                            <span>{t('recommendation.left.futureJob.group1.title')}</span>
                        </h3>
                        <img src="https://images.feel-good.io/guide/left/left_06.png" alt={'6'}/>

                        <ul className={style.description}>
                            {renderListItems(19, 1,job)}
                        </ul>
                    </section>
                </article>
                <article className={style.subArticle}>
                    <section>
                        <h3 className={style.title}>
                            <span className={style.number}>2</span>
                            <span>{t('recommendation.left.futureJob.group3.title')}</span>
                        </h3>
                        <img src="https://images.feel-good.io/guide/left/left_07.png" alt={'7'}/>

                        <ul className={style.description}>
                            {renderListItems(14, 2,job)}
                        </ul>
                    </section>
                </article>
                <article className={style.subArticle}>
                    <section>
                        <h3 className={style.title}>
                            <span className={style.number}>3</span>
                            <span>{t('recommendation.left.futureJob.group3.title')}</span>
                        </h3>
                        <img src="https://images.feel-good.io/guide/left/left_08.png" alt={'8'}/>
                        <ul className={style.description}>
                            {renderListItems(14, 3,job)}
                        </ul>
                    </section>
                </article>
                <article className={style.subArticle}>
                    <section>
                        <h3 className={style.title}>
                            <span className={style.number}>4</span>
                            <span>{t('recommendation.left.futureJob.group4.title')}</span>
                        </h3>
                        <img src="https://images.feel-good.io/guide/left/left_09.png" alt={'9'}/>
                        <ul className={style.description}>
                            {renderListItems(11, 4,job)}
                        </ul>
                    </section>
                </article>
            </article>
        </>
    )
}